import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import styles from './Product.module.sass';
import { productsActions } from '../../actions';
import ProductInfo from './product_info/ProductInfo';
import ImagesSlider from './images_slider/ImagesSlider';
import { userObjectSelector } from '../../../user/selectors/user';
import { campaignsActions } from '../../../campaigns/actions';
import { campaignsObjectsSelector } from '../../../campaigns/selectors/campaigns';
import { totalReviewsSelector } from '../../selectors/reviews';
import { modalsActions } from '../../../modals/actions';
import MODALS from '../../../modals/constants/modals';

const SHOW_PREORDER_MODAL = false;

class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDeliveryFrequency: 0,
    };
  }

  componentDidMount() {
    const {
      addProduct, product, variant, campaigns, openPreorderModal, user, campaignId,
    } = this.props;

    const campaign = campaigns.find((object) => object.id === campaignId);

    if (SHOW_PREORDER_MODAL && campaign && campaign.available_for_preorder && !user && !Cookies.get('join_the_lounge_for_preorder_popup_shown')) {
      Cookies.set('signed_up_from', 'preordering');
      openPreorderModal();
    }

    addProduct({ ...product, variantId: variant.id });
  }

  addToBagClickHandler = () => {
    const { addToBagRequest, variant, product } = this.props;
    const { selectedDeliveryFrequency } = this.state;
    const productId = product.id;
    const variantId = variant.id;

    addToBagRequest({ id: productId, variantId, frequency: selectedDeliveryFrequency });
  };

  setSelectedDeliveryFrequency = (selectedDeliveryFrequency) => {
    this.setState({ selectedDeliveryFrequency });
  };

  render() {
    const {
      product, products, variant,
      images, productSubscribe, user, subscriptionDiscountPercentage = 0, campaignId,
      selectVariant, campaigns, totalReviews, upvote, downvote,
    } = this.props;

    const campaign = campaigns.find((object) => object.id === campaignId);

    const { backgroundImage } = product;

    const { selectedDeliveryFrequency } = this.state;

    return (
      <div className={styles.product}>
        { images && backgroundImage && (
          <ImagesSlider
            backgroundImage={backgroundImage}
            images={images}
            title={product.name}
            slug={product.slug}
            badge={(campaign && (campaign.available_for_preorder ? 'Pre-Order' : 'Waitlist')) || null}
          />
        )}
        <ProductInfo
          product={product}
          variant={variant}
          products={products}
          addToBagClickHandler={this.addToBagClickHandler}
          productSubscribe={productSubscribe}
          selectedDeliveryFrequency={selectedDeliveryFrequency}
          setSelectedDeliveryFrequency={this.setSelectedDeliveryFrequency}
          user={user}
          subscriptionDiscountPercentage={subscriptionDiscountPercentage}
          campaign={campaign}
          selectVariant={(variantId) => {
            if (!campaign) { return; }

            selectVariant(campaign.id, variantId);
          }}
          totalReviews={totalReviews}
          upvote={upvote}
          downvote={downvote}
        />
      </div>
    );
  }
}

Product.propTypes = {
  addToBagRequest: PropTypes.func.isRequired,
  addProduct: PropTypes.func.isRequired,
  product: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    backgroundImage: PropTypes.string,
    slug: PropTypes.string,
  }).isRequired,
  variant: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  images: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.arrayOf(
      PropTypes.shape({ url: PropTypes.string, placeholder: PropTypes.string }),
    ),
  ]),
  productSubscribe: PropTypes.func.isRequired,
  user: PropTypes.shape({}),
  subscriptionDiscountPercentage: PropTypes.number,
  campaigns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    }),
  ).isRequired,
  selectVariant: PropTypes.func.isRequired,
  campaignId: PropTypes.number,
  totalReviews: PropTypes.number,
  upvote: PropTypes.func.isRequired,
  downvote: PropTypes.func.isRequired,
  openPreorderModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  products: state.products.objects,
  user: userObjectSelector(state),
  campaigns: campaignsObjectsSelector(state),
  totalReviews: totalReviewsSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  addToBagRequest: (product) => dispatch(productsActions.addToBagRequest(product)),
  addProduct: (product) => dispatch(productsActions.addProducts([product])),
  productSubscribe: (product) => dispatch(productsActions.productSubscribeRequest(product)),
  selectVariant: (campaignId, variantId) => dispatch(
    campaignsActions.selectVariantId({ id: campaignId, selectedVariantId: variantId }),
  ),
  upvote: (campaignId) => dispatch(
    campaignsActions.upvoteRequest({ campaignId }),
  ),
  downvote: (campaignId) => dispatch(
    campaignsActions.downvoteRequest({ campaignId }),
  ),
  openPreorderModal: () => dispatch(
    modalsActions.openModalRequest({ modal: MODALS.JOIN_THE_LOUNGE_FOR_PREORDERING }),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Product);
